import firebase from 'firebase/app';
import 'firebase/firestore';

var firebaseConfig = {
    apiKey: "AIzaSyCyBfSRg_BqwKxdY3nZt0WOVZhqZAssU8s",
    authDomain: "portfolio-cv-c9263.firebaseapp.com",
    projectId: "portfolio-cv-c9263",
    storageBucket: "portfolio-cv-c9263.appspot.com",
    messagingSenderId: "678449950484",
    appId: "1:678449950484:web:879322245799bb4747dc01"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  export default firebase